import { useTranslation } from 'react-i18next'

interface AppErrorFallbackProps {
  incidentRef?: string | null
  onReset?: () => void
}

export default function AppErrorFallback({ incidentRef, onReset }: AppErrorFallbackProps) {
  const { t } = useTranslation()
  const title = t('common.error.title')
  const message = t('common.error.message')
  const actionLabel = t('common.error.refresh')

  return (
    <div className="app-error">
      <h1>{title}</h1>
      <p>{message}</p>
      {incidentRef ? <p>Ref: {incidentRef}</p> : null}
      <button type="button" onClick={() => (onReset ? onReset() : window.location.reload())}>
        {actionLabel}
      </button>
    </div>
  )
}
